var map = {
	"./amex.svg": 7118,
	"./carnet.svg": 3664,
	"./crm.svg": 3961,
	"./diners.svg": 9272,
	"./magna.svg": 459,
	"./master.svg": 1549,
	"./presto.svg": 4098,
	"./visa.svg": 8932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;